import { YooKassaSuccessPayment } from './ui';

export { YooKassaSuccessPayment };
